import React from 'react';
import Navbar from '../components/nav/Navbar';
import Footer from '../components/nav/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 text-zinc-100">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-8 py-24 space-y-12 relative z-10">
        <div className="space-y-4">
          <span className="text-xs font-black tracking-widest text-brand-pink uppercase">Legal</span>
          <h1 className="text-5xl font-black tracking-tighter text-white uppercase">Privacy Policy</h1>
          <p className="text-zinc-500 font-bold uppercase tracking-widest text-xs">Last Updated: October 24, 2026</p>
        </div>
        
        <div className="space-y-8 text-zinc-300 text-lg leading-relaxed glass-panel p-8 md:p-12 rounded-3xl">
          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">1. Information We Collect</h2>
            <p>We collect information you provide directly to us, such as when you create or modify your account, request on-demand services, contact customer support, or otherwise communicate with us. This information may include: name, email, phone number, postal address, profile picture, payment method, and other information you choose to provide.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">2. How We Use Your Information</h2>
            <p>We may use the information we collect about you to:</p>
            <ul className="list-disc pl-6 space-y-2 text-zinc-400">
              <li>Provide, maintain, and improve our Services;</li>
              <li>Perform internal operations, including to prevent fraud and abuse of our Services;</li>
              <li>Send you communications we think will be of interest to you;</li>
              <li>Personalize and improve the Services.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">3. Sharing of Information</h2>
            <p>We may share the information we collect about you with vendors, consultants, marketing partners, and other service providers who need access to such information to carry out work on our behalf. We may also share your information in response to a request for information by a competent authority if we believe disclosure is in accordance with any applicable law.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;